require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-mattersburg-poettsching.json") })
        }
      }, "path---betreuungseinrichtungen-mattersburg-poettsching");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-mattersburg-poettsching!./.cache/json/betreuungseinrichtungen-mattersburg-poettsching.json
// module id = 935
// module chunks = 231608221292675